module.exports = "https://web-assets.ifttt.com/packs/media/docs/applet-version-id-on-applet-page-b45c57cb.png";